import { defineNuxtPlugin } from '#imports'

// Best practice: avoid intercepting/suppressing DevTools errors.
// If needed, keep this plugin inert to prevent masking real issues.
export default defineNuxtPlugin({
  name: 'vue-devtools-minimal-protection',
  enforce: 'pre',
  setup() {
    // Intentionally no-op to follow Nuxt/Vue DevTools best practices
    return
  }
})